import React from 'react';
import { Panel } from '@tanium/react-panel';
import { useTranslation } from 'react-i18next';
import { Box } from '@tanium/react-box';
import { Stack } from '@tanium/react-stack';
import { DefinitionList, DefinitionListItem } from '@tanium/react-definition-list';
import MediumBoldText from 'components/styles/text/MediumBoldText';
import MediumText from 'components/styles/text/MediumText';
import { safeConvertBooleanToString } from 'utils/Helper';

export interface INotificationInfoDisplayProps {
  approvalSlackChannel?: string;
  notifyAutoApproval?: boolean;
  enablePaging?: boolean;
}
export const NotificationInfoDisplay = ({
  approvalSlackChannel,
  notifyAutoApproval,
  enablePaging,
}: INotificationInfoDisplayProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <>
      <Panel title={t('NOTIFICATION_INFO')}>
        <Box pl={7}>
          <Stack itemSpacing={10} direction="columns">
            <DefinitionList>
              {approvalSlackChannel !== undefined && (
                <DefinitionListItem
                  term={<MediumText>{t('APPROVAL_SLACK_CHANNEL')}:</MediumText>}
                  description={<MediumBoldText>{approvalSlackChannel}</MediumBoldText>}
                />
              )}
              {notifyAutoApproval !== undefined && (
                <DefinitionListItem
                  term={<MediumText>{t('NOTIFY_AUTO_APPROVAL')}:</MediumText>}
                  description={<MediumBoldText>{t(safeConvertBooleanToString(notifyAutoApproval))}</MediumBoldText>}
                />
              )}
              {enablePaging !== undefined && (
                <DefinitionListItem
                  term={<MediumText>{t('ENABLE_PAGING')}:</MediumText>}
                  description={<MediumBoldText>{t(safeConvertBooleanToString(enablePaging))}</MediumBoldText>}
                />
              )}
            </DefinitionList>
          </Stack>
        </Box>
      </Panel>
    </>
  );
};

export default NotificationInfoDisplay;
